import React from 'react';
import { IonText, IonIcon } from '@ionic/react';
import { checkmarkCircle, closeCircle } from 'ionicons/icons';

interface PasswordRequirementsProps {
    password: string;
    showValidation?: boolean;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password, showValidation = true }) => {
    const requirements = [
        {
            label: 'At least 8 characters long',
            check: (p: string) => p.length >= 8
        },
        {
            label: 'Contains at least one uppercase letter',
            check: (p: string) => /[A-Z]/.test(p)
        },
        {
            label: 'Contains at least one lowercase letter',
            check: (p: string) => /[a-z]/.test(p)
        },
        {
            label: 'Contains at least one number',
            check: (p: string) => /[0-9]/.test(p)
        },
        {
            label: 'Contains at least one special character (!@#$%^&*(),.?"\':{}<>)',
            check: (p: string) => /[!@#$%^&*(),.?"':{}<>]/.test(p)
        },
        {
            label: 'No repeating characters (e.g., "aaa")',
            check: (p: string) => !/(.)\1{2,}/.test(p)
        },
        {
            label: 'No sequential characters (e.g., "123", "abc")',
            check: (p: string) => {
                // Check for sequential numbers
                if (/(?:012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210)/.test(p)) return false;
                
                // Check for sequential letters
                const lowerP = p.toLowerCase();
                if (/(?:abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|rst|stu|tuv|uvw|vwx|wxy|xyz)/.test(lowerP)) return false;
                
                return true;
            }
        }
    ];

    if (!showValidation) {
        return (
            <div className="ion-padding-vertical">
                <IonText color="medium">
                    <h6>Password Requirements:</h6>
                    <ul style={{ paddingLeft: '20px', margin: '8px 0' }}>
                        {requirements.map((req, index) => (
                            <li key={index}>{req.label}</li>
                        ))}
                    </ul>
                </IonText>
            </div>
        );
    }

    return (
        <div className="ion-padding-vertical">
            <IonText color="medium">
                <h6>Password Requirements:</h6>
            </IonText>
            <ul style={{ listStyle: 'none', padding: 0, margin: '8px 0' }}>
                {requirements.map((req, index) => {
                    const isValid = password ? req.check(password) : false;
                    return (
                        <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                            <IonIcon
                                icon={isValid ? checkmarkCircle : closeCircle}
                                color={isValid ? 'success' : 'medium'}
                                style={{ marginRight: '8px' }}
                            />
                            <IonText color={isValid ? 'success' : 'medium'}>
                                {req.label}
                            </IonText>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}; 